import { useSelector } from 'app-redux'
import { selectFocusedFeature } from 'room/training-room/redux'
import { selectYouTubeStreamState } from './youtube-streaming-redux'
import { FocusedFeatureTypes } from 'common/types'

export const useDisableFeatureOnYouTubeStreamPlaying = (): boolean => {
	const focusedFeature = useSelector(selectFocusedFeature)
	const youTubeStreamingState = useSelector(selectYouTubeStreamState)

	return (
		focusedFeature?.type === FocusedFeatureTypes.YOUTUBE_STREAMING &&
		youTubeStreamingState?.state === 'Playing'
	)
}
